const API_URL = 'https://perigon.zedbrains.com/v8';
// const API_URL = 'http://127.0.0.1:4839/v8';
exports.FETCH_URL = 'https://cloud.zedbrains.com/app.perigon/uploads/';

exports.SIGNIN_URL = `${API_URL}/signin`;
exports.GET_USER_STATISTICS_URL = `${API_URL}/user-statistics`;
exports.GET_USER_REGISTRATS_URL = `${API_URL}/user-registrats`;
exports.GET_PROPERTY_STATISTICS_URL = `${API_URL}/property-statistics`;
exports.GET_PROPERTY_URL = `${API_URL}/get-property`;
exports.PUSH_NOTIFICATION = `${API_URL}/push-notification`;
exports.ACTION_NOTIFICATION = `${API_URL}/action-notification`;
exports.GET_AGENT_DATA = `${API_URL}/get-agent-data`;
exports.GET_NOTIFICATION_LIST_URL = `${API_URL}/get-notification-list`;
exports.ADD_COUNTRY_LIST_URL = `${API_URL}/add-country`;
exports.DELETE_COUNTRY_URL = `${API_URL}/delete-country`;
exports.STATE_COUNTRY_URL = `${API_URL}/state-country`;
exports.GET_COUNTRY_LIST_URL = `${API_URL}/get-country-list`;
exports.DELETE_ADMIN_URL = `${API_URL}/delete-admin`;
exports.DELETE_AGENT_URL = `${API_URL}/delete-agent`;
exports.DELETE_PROPERTY_URL = `${API_URL}/delete-property`;
exports.ADD_ADMIN_USER_URL = `${API_URL}/add-admin-user`;
exports.ADD_AGENT_USER_URL = `${API_URL}/add-agent-user`;
exports.GET_ACCESS_CONTROL_URL = `${API_URL}/access-control`;
exports.GET_AGENT_LISt_URL = `${API_URL}/get-agent`;
exports.EDIT_ADMIN_USER_URL = `${API_URL}/edit-admin-user`;
exports.DEACTIVATE_PROPERTY_URL = `${API_URL}/deactivate-property`;
exports.EDIT_AGENT_USER_URL = `${API_URL}/edit-agent-user`;
exports.GET_COUNTRY_DATA = `${API_URL}/get-country-data`;
exports.GET_CATEGORY_DATA = `${API_URL}/get-category-data`;
exports.UPLOAD_PROPERTY_URL = `${API_URL}/upload-property`;
exports.EDIT_PROPERTY_URL = `${API_URL}/edit-property`;
